//require('es6-promise/auto');


////ライブラリ読み込み
//CSS
require("scss/main.scss");
require('!style-loader!css-loader!sass-loader!font-awesome/scss/font-awesome.scss');



//ライブラリ
import "bootstrap"
import {dd,store,app} from 'systems/imports'

//Vueライブラリ
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'

Vue.use(Vuelidate)
Vue.use(VueI18n)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/dist/error_icon.png",
  loading: "/dist/lodding.gif",
})

//アプリ
import router from 'systems/router'
import Wrap from 'Wrap.vue'

// グローバル登録
import TransText from 'components/widget/TransText.vue'
Vue.component('trans-text', TransText);

//ディレクティブ適用
import 'systems/directives'

//初期化処理
window.vm = new Vue({
  data(){
   return {
     windowWidth:0,
     windowHeight:0,
     headerHeight:0, //上部固定ヘッダーの高さ
     footerHeight:0, //下部固定フッターの高さ
     bootstrapBreakpoint:null, //Bootstrapの現在の幅のブレークポイント
     isLoggedInPage:false,
     lastAtAdjustLayout:0,
     lastWindowClick:0,
     user:{},
    }
  },
  methods:{
  },
  watch: {
    bootstrapBreakpoint: function (val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal)
    }
  },
  el: '#app',
  render: h => h(Wrap),
  router,
})

import "systems/jquery"



// WEBPACK FOOTER //
// ./src/main.js